"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconStamp = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M59.2 37.41H43.06v-9l2.45-3.92A12.2 12.2 0 0 0 35.17 5.83h-.34a12.2 12.2 0 0 0-10.34 18.66l2.45 3.92v9H10.8A1.6 1.6 0 0 0 9.2 39v14.25a1.6 1.6 0 0 0 1.6 1.6h48.4a1.6 1.6 0 0 0 1.6-1.6V39a1.6 1.6 0 0 0-1.6-1.59zM25.83 18a9 9 0 0 1 9-9h.34a9 9 0 0 1 7.63 13.8l-2.7 4.31a1.6 1.6 0 0 0-.24.85v9.45h-9.72V28a1.6 1.6 0 0 0-.24-.85l-2.7-4.35a9 9 0 0 1-1.37-4.8zM57.6 51.65H12.4v-11h45.2zM17.7 60.17h34.6A3.2 3.2 0 0 0 55.5 57h-41a3.2 3.2 0 0 0 3.2 3.17z"
  })),
  height: undefined,
  width: undefined
});
IconStamp.displayName = 'IconStamp';
var _default = IconStamp;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/stamp.js
// module id = 618
// module chunks = 0